import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query";
import { ANALYTICS_QUERY_GC_TIME } from "../../constants";
import { useTemporalApiClient } from "../../context/TemporalApiClientProvider";
import CoreAPIClientError from "../core/CoreAPIClientError";

type Options = UseMutationOptions<
  string,
  CoreAPIClientError,
  { tenantID: string; integrationID: string }
>;

type Result = UseMutationResult<
  string,
  CoreAPIClientError,
  { tenantID: string; integrationID: string }
>;

export function useCreateBillingV3Workflow(options?: Options): Result {
  const client = useTemporalApiClient();

  return useMutation({
    mutationFn: (params) => client.createBillingV3Workflow(params),
    gcTime: ANALYTICS_QUERY_GC_TIME,
    ...options,
  });
}
